export default __webpack_public_path__ + "static/media/Party-Room.3003a652.webp";